import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { SignupComponent } from "../../shared/signup/signup.component";
import {BaseRequestService} from "../../../_services/base.service";
import {SkeletonComponent} from "../../shared/skeleton/skeleton.component";
import {NgIf} from "@angular/common";
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'auth-sign-up',
    templateUrl: './sign-up.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [SignupComponent, SkeletonComponent, NgIf],
})
export class AuthSignUpComponent implements OnInit, OnDestroy {
    regions: any;
    signUpConf: any = {
        title: 'Sign Up',
        spanLayout: 2,
        showTopAlert: false,
        showBottomAlert: true,
        formElements: [
            {
                "name": "email",
                "description": "Email",
                "example": "",
                "required": true,
                "schema": {
                    "type": "email"
                }
            },
            {
                "name": "company",
                "description": "Company",
                "required": true,
                "schema": {
                    "type": "text"
                }
            },
            {
                "name": "first_name",
                "description": "Firstname",
                "example": "",
                "required": true,
                "schema": {
                    "type": "text"
                }
            },
            {
                "name": "last_name",
                "description": "Lastname",
                "example": "",
                "required": true,
                "schema": {
                    "type": "text"
                }
            },
            {
                "name": "password",
                "description": "Password",
                "example": "Min 8 chars, 1 caps letter, 1 small letter, 1 special letter",
                "min": 8,
                "max": 63,
                "required": true,
                "schema": {
                    "type": "password"
                }
            },
            {
                "name": "confirm_password",
                "description": "Confirm Password",
                "example": "Min 8 chars, 1 caps letter, 1 small letter, 1 special letter",
                "min": 8,
                "max": 63,
                "required": true,
                "schema": {
                    "type": "password"
                }
            },
            {
                "name": "country",
                "description": "Choose Country",
                "example": "",
                "required": true,
                searching: true,
                "options": [{ "displayName": "Afghanistan" }, { "displayName": "Albania" }, { "displayName": "Algeria" }, { "displayName": "Andorra" }, { "displayName": "Angola" }, { "displayName": "Antigua and Barbuda" }, { "displayName": "Argentina" }, { "displayName": "Armenia" }, { "displayName": "Australia" }, { "displayName": "Austria" }, { "displayName": "Azerbaijan" }, { "displayName": "Bahamas" }, { "displayName": "Bahrain" }, { "displayName": "Bangladesh" }, { "displayName": "Barbados" }, { "displayName": "Belarus" }, { "displayName": "Belgium" }, { "displayName": "Belize" }, { "displayName": "Benin" }, { "displayName": "Bhutan" }, { "displayName": "Bolivia" }, { "displayName": "Bosnia and Herzegovina" }, { "displayName": "Botswana" }, { "displayName": "Brazil" }, { "displayName": "Brunei" }, { "displayName": "Bulgaria" }, { "displayName": "Burkina Faso" }, { "displayName": "Burundi" }, { "displayName": "Cote dIvoire" }, { "displayName": "Cabo Verde" }, { "displayName": "Cambodia" }, { "displayName": "Cameroon" }, { "displayName": "Canada" }, { "displayName": "Central African Republic" }, { "displayName": "Chad" }, { "displayName": "Chile" }, { "displayName": "China" }, { "displayName": "Colombia" }, { "displayName": "Comoros" }, { "displayName": "Congo (Congo-Brazzaville)" }, { "displayName": "Costa Rica" }, { "displayName": "Croatia" }, { "displayName": "Cuba" }, { "displayName": "Cyprus" }, { "displayName": "Czechia (Czech Republic)" }, { "displayName": "Democratic Republic of the Congo" }, { "displayName": "Denmark" }, { "displayName": "Djibouti" }, { "displayName": "Dominica" }, { "displayName": "Dominican Republic" }, { "displayName": "Ecuador" }, { "displayName": "Egypt" }, { "displayName": "El Salvador" }, { "displayName": "Equatorial Guinea" }, { "displayName": "Eritrea" }, { "displayName": "Estonia" }, { "displayName": "Eswatini (fmr. \"Swaziland\")" }, { "displayName": "Ethiopia" }, { "displayName": "Fiji" }, { "displayName": "Finland" }, { "displayName": "France" }, { "displayName": "Gabon" }, { "displayName": "Gambia" }, { "displayName": "Georgia" }, { "displayName": "Germany" }, { "displayName": "Ghana" }, { "displayName": "Greece" }, { "displayName": "Grenada" }, { "displayName": "Guatemala" }, { "displayName": "Guinea" }, { "displayName": "Guinea-Bissau" }, { "displayName": "Guyana" }, { "displayName": "Haiti" }, { "displayName": "Holy See" }, { "displayName": "Honduras" }, { "displayName": "Hungary" }, { "displayName": "Iceland" }, { "displayName": "India" }, { "displayName": "Indonesia" }, { "displayName": "Iran" }, { "displayName": "Iraq" }, { "displayName": "Ireland" }, { "displayName": "Israel" }, { "displayName": "Italy" }, { "displayName": "Jamaica" }, { "displayName": "Japan" }, { "displayName": "Jordan" }, { "displayName": "Kazakhstan" }, { "displayName": "Kenya" }, { "displayName": "Kiribati" }, { "displayName": "Kuwait" }, { "displayName": "Kyrgyzstan" }, { "displayName": "Laos" }, { "displayName": "Latvia" }, { "displayName": "Lebanon" }, { "displayName": "Lesotho" }, { "displayName": "Liberia" }, { "displayName": "Libya" }, { "displayName": "Liechtenstein" }, { "displayName": "Lithuania" }, { "displayName": "Luxembourg" }, { "displayName": "Madagascar" }, { "displayName": "Malawi" }, { "displayName": "Malaysia" }, { "displayName": "Maldives" }, { "displayName": "Mali" }, { "displayName": "Malta" }, { "displayName": "Marshall Islands" }, { "displayName": "Mauritania" }, { "displayName": "Mauritius" }, { "displayName": "Mexico" }, { "displayName": "Micronesia" }, { "displayName": "Moldova" }, { "displayName": "Monaco" }, { "displayName": "Mongolia" }, { "displayName": "Montenegro" }, { "displayName": "Morocco" }, { "displayName": "Mozambique" }, { "displayName": "Myanmar (formerly Burma)" }, { "displayName": "Namibia" }, { "displayName": "Nauru" }, { "displayName": "Nepal" }, { "displayName": "Netherlands" }, { "displayName": "New Zealand" }, { "displayName": "Nicaragua" }, { "displayName": "Niger" }, { "displayName": "Nigeria" }, { "displayName": "North Korea" }, { "displayName": "North Macedonia" }, { "displayName": "Norway" }, { "displayName": "Oman" }, { "displayName": "Pakistan" }, { "displayName": "Palau" }, { "displayName": "Palestine State" }, { "displayName": "Panama" }, { "displayName": "Papua New Guinea" }, { "displayName": "Paraguay" }, { "displayName": "Peru" }, { "displayName": "Philippines" }, { "displayName": "Poland" }, { "displayName": "Portugal" }, { "displayName": "Qatar" }, { "displayName": "Romania" }, { "displayName": "Russia" }, { "displayName": "Rwanda" }, { "displayName": "Saint Kitts and Nevis" }, { "displayName": "Saint Lucia" }, { "displayName": "Saint Vincent and the Grenadines" }, { "displayName": "Samoa" }, { "displayName": "San Marino" }, { "displayName": "Sao Tome and Principe" }, { "displayName": "Saudi Arabia" }, { "displayName": "Senegal" }, { "displayName": "Serbia" }, { "displayName": "Seychelles" }, { "displayName": "Sierra Leone" }, { "displayName": "Singapore" }, { "displayName": "Slovakia" }, { "displayName": "Slovenia" }, { "displayName": "Solomon Islands" }, { "displayName": "Somalia" }, { "displayName": "South Africa" }, { "displayName": "South Korea" }, { "displayName": "South Sudan" }, { "displayName": "Spain" }, { "displayName": "Sri Lanka" }, { "displayName": "Sudan" }, { "displayName": "Suriname" }, { "displayName": "Sweden" }, { "displayName": "Switzerland" }, { "displayName": "Syria" }, { "displayName": "Tajikistan" }, { "displayName": "Tanzania" }, { "displayName": "Thailand" }, { "displayName": "Timor-Leste" }, { "displayName": "Togo" }, { "displayName": "Tonga" }, { "displayName": "Trinidad and Tobago" }, { "displayName": "Tunisia" }, { "displayName": "Turkey" }, { "displayName": "Turkmenistan" }, { "displayName": "Tuvalu" }, { "displayName": "Uganda" }, { "displayName": "Ukraine" }, { "displayName": "United Arab Emirates" }, { "displayName": "United Kingdom" }, { "displayName": "United States of America" }, { "displayName": "Uruguay" }, { "displayName": "Uzbekistan" }, { "displayName": "Vanuatu" }, { "displayName": "Venezuela" }, { "displayName": "Vietnam" }, { "displayName": "Yemen" }, { "displayName": "Zambia" }, { "displayName": "Zimbabwe" }],
                "schema": {
                    "type": "dropdown",
                    "key": "displayName",
                    "value": "displayName",
                }
            },
            {
                "name": "city",
                "description": "City",
                "example": "",
                "required": true,
                "schema": {
                    "type": "text"
                }
            },
            {
                "name": "state",
                "description": "State",
                "example": "",
                "required": true,
                "schema": {
                    "type": "text"
                }
            },
            {
                "name": "mobile",
                "description": "Mobile",
                "example": "",
                "max": 10,
                "min": 10,
                "required": true,
                "schema": {
                    "type": "number"
                }
            },
            {
                "name": "region",
                "description": "Choose Region",
                "example": "",
                "required": true,
                "options":[],
                "schema": {
                    "type": "dropdown",
                    "key": "displayName",
                    "value": "name",
                }
            },
            {
                "name": "tenant_name",
                "description": "Tenant Name",
                "example": "No special letters",
                "required": true,
                "min": 3,
                "max": 63,
                "schema": {
                    "type": "text"
                }
            },
            {
                "name": "tokenControl",
                "description": "",
                "required": false,
                "schema": {
                    "type": "s_captcha"
                }
            },
        ],
        token: 'nklYPAPFSkj6oz9weitIME_1oP-TVkOEZDEkK9LmSV5-mKbJnc2SfbOKFqyfP-rYFW4ay9s',
        url: '/w/mssp/register',
        redirectRouterLink: '/sign-in',
        passLength: 8,
        logo: '/w/mssp/register',
        fnBtnName: 'Submit',
        closeBtnName: 'Return to login',
        objectMapping: [
            { "source": "email", "destination": "email" },
            { "source": "company", "destination": "company" },
            { "source": "first_name", "destination": "first_name" },
            { "source": "last_name", "destination": "last_name" },
            { "source": "password", "destination": "password" },
            { "source": "city", "destination": "city" },
            { "source": "state", "destination": "state" },
            { "source": "country", "destination": "country" },
            { "source": "mobile", "destination": "mobile" },
            { "source": "region", "destination": "region" },
            { "source": "tenant_name", "destination": "tenant_name" }
        ],
        isComponentSide: true,
    }
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    /**
     * Constructor
     */
    constructor(private _bs: BaseRequestService) {
    }

    ngOnInit() {
        this._bs.doRequest('https://configuration.myconnectsecure.com/api/getRegions', 'get')
        .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
            if (result.status) {
                this.signUpConf.formElements.forEach((obj: any) => {
                    if (obj.name === 'region') {
                        obj.options = result.message;
                    }
                });
                this.regions = result.message;
            } else {
                console.log("Error in getRegions");
            }
        });
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
